import { googleTools } from '@ai-sdk/google/internal';

export const googleVertexTools = {
  googleSearch: googleTools.googleSearch,
  urlContext: googleTools.urlContext,
  fileSearch: googleTools.fileSearch,
  codeExecution: googleTools.codeExecution,
};
